/*** IMPORTS FROM imports-loader ***/
var define = false;

var conf = require('./conf')

module.exports = {
  /*
   * 对象拓展
   * @param {Object} [out] - 拓展初始对象
   * @returns {Object} 拓展后对象
   */
  deepExtend: function (out) {
    out = out || {};

    for (var i = 1; i < arguments.length; i++) {
      var obj = arguments[i];

      if (!obj)
        continue;

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'object' && obj[key] !== null)
            out[key] = this.deepExtend(out[key], obj[key]);
          else
            out[key] = obj[key];
        }
      }
    }

    return out;
  },

  /*
   * 格式化参数
   * @param {Object} data - 格式化对象
   * @returns {string} 格式化后字符串
   */
  formatParams: function (data) {
    var arr = [];
    for (var name in data) {
      if (data.hasOwnProperty(name)) {
        arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
      }
    }
    return arr.join('&');
  },

  /**
   * 发送 jsonp 请求
   * @function jsonp
   * @param {object} options - 请求选项
   * @param {string} options.url - 请求url
   * @param {string} options.callback - 回调方法名
   * @param {object} options.data - 请求数据
   * @param {function} options.success - 成功回调
   * @param {function} options.fail - 失败回调
   */
  jsonp: function (options) {
    options = options || {};

    if (!options.url || !options.callback) {
      throw new Error('参数不合法');
    }

    // 创建 script 标签并加入到页面中
    var oHead = document.getElementsByTagName('head')[0];
    var params = '';
    if (options.data) {
      options.data.callback = options.callback;
      params += this.formatParams(options.data);
    } else {
      params += 'callback=' + options.callback;
    }
    var oS = document.createElement('script');
    oHead.appendChild(oS);

    // 创建jsonp回调函数
    window[options.callback] = function (json) {
      oHead.removeChild(oS);
      clearTimeout(oS.timer);
      window[options.callback] = null;
      options.success && options.success(json);
    };

    // 发送请求
    oS.src = options.url + '?' + params;

    // 超时处理
    if (options.time) {
      oS.timer = setTimeout(function () {
        window[options.callback] = null;
        oHead.removeChild(oS);
        options.fail && options.fail({ message: "超时" });
      }, options.time);
    }
  },

  /**
   * @func setCookie
   * @desc 设置cookie字段
   * @param {string} domain - cookie域名
   * @param {string} key - cookie参数
   * @param {string} value - cookie值
   * @param {number} hour - 过期小时数
   */
  setCookie: function (domain, key, value, hour) {
    if (hour) {
      var i = new Date((new Date()).getTime() + hour * 36e5);
      document.cookie = key + "=" + escape(value) + ";path=/;domain=" + domain + ";expires=" + i.toGMTString();
    } else {
      document.cookie = key + "=" + escape(value) + ";path=/;domain=" + domain;
    }
  },

  /**
   * @func getCookie
   * @desc 获取cookie字段
   * @param {string} name - 字段名 
   * @returns {(string|object)} 返回字段值或整个cookie对象
   */
  getCookie: function (name) {
    var cookie = {};
    var cookieSplit = document.cookie.split('; ');
    var keyValue;

    for (var i = 0; i < cookieSplit.length; i++) {
      keyValue = cookieSplit[i].split('=');
      cookie[keyValue[0]] = keyValue[1];
    }

    return name ? cookie[name] : cookie;
  },

  /**
   * 用户登出时清除cookie
   * @method clearCookie
   */
  clearCookie: function () {
    document.cookie = 'userid=0;domain=xunlei.com;path=/;expires=' + new Date(0).toUTCString();
    document.cookie = 'sessionid=0;domain=xunlei.com;path=/;expires=' + new Date(0).toUTCString();
  },

  /**
   * 实现类 Function.prototype.apply 方法
   * @function apply
   */
  apply: function (fcn, args) {
    var cmd = fcn + '('; // 执行语句
    var params = []; // 参数列表
    var val; // 返回值

    for (var i = 0; i < args.length; i++) {
      params.push('args[' + i + ']');
    }

    cmd += params.join(',');
    cmd += ')';

    return eval(cmd);
  }
}




//////////////////
// WEBPACK FOOTER
// ./util.js
// module id = 4
// module chunks = 0